module.exports = __webpack_public_path__ + "media/browser/safari-642942fe.svg";